/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file-image': {
    width: 18,
    height: 24,
    viewBox: '0 0 18 24',
    data: '<defs><path pid="0" id="svgicon_file-image_a" d="M18 11.721V0H0v23.442h18z"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_file-image_b" _fill="#fff"><use xlink:href="#svgicon_file-image_a"/></mask><path pid="1" _fill="#292929" d="M16.744 19.465a2.715 2.715 0 01-2.72 2.72H3.976a2.715 2.715 0 01-2.721-2.72V3.977a2.716 2.716 0 012.72-2.721h6.322v3.767A2.323 2.323 0 0012.6 7.325h4.144v12.14zM11.847.628C11.427.209 10.842 0 10.256 0h-6.28C1.8 0 0 1.8 0 3.977v15.488c0 2.177 1.8 3.977 3.977 3.977h10.046c2.177 0 3.977-1.8 3.977-3.977V7.41c0-.628-.251-1.256-.712-1.675L11.847.628z" mask="url(#svgicon_file-image_b)"/><path pid="2" _fill="#292929" d="M7.535 12.365l1.884 1.883a.127.127 0 00.167 0l1.381-1.13a.127.127 0 01.168 0l3.349 3.558c.083.084 0 .21-.084.21H3.558c-.125 0-.167-.126-.084-.21l3.893-4.311c.042-.084.126-.084.168 0m4.312-3.726c.711 0 1.297.586 1.297 1.298 0 .711-.586 1.297-1.297 1.297a1.304 1.304 0 01-1.298-1.297c0-.712.586-1.298 1.298-1.298"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/file-image.js